import { makeProvider } from "../../makeProvider"
import { NumberTestLogic } from "./logic"

const {Provider, useStore} = makeProvider(NumberTestLogic)

export const NumberProvider = Provider
export const useNumberCounter = useStore
